import { render, staticRenderFns } from "./AssessmentDetails.vue?vue&type=template&id=21ee6350&scoped=true&"
import script from "./AssessmentDetails.vue?vue&type=script&lang=js&"
export * from "./AssessmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentDetails.vue?vue&type=style&index=0&id=21ee6350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ee6350",
  null
  
)

export default component.exports